export default function emailFieldToggle() {
  $('.email-conditional-parent').keyup(function () {
    if (this.value.length > 0) {
      $('.email-conditional-child').show();
    } else {
      $('.email-conditional-child').hide();
    }
  });
}
